(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {

		//
		var $body = $('body');

		//
		$body.on('click', '[data-toggle-user-menu]', function() {
			$body.toggleClass('user-menu-open');
		})
	});
})(window.jQuery)
